import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import type { ReferencedDecisionsInterface } from '@/types/api-types';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import DecisionItem from './decision-item';

interface DecisionsSidebarProps {
  decisions: ReferencedDecisionsInterface[];
  selectedDecision: ReferencedDecisionsInterface | null;
  isLoading: boolean;
  onSelectDecision: (decision: ReferencedDecisionsInterface) => void;
  onScroll: (e: React.UIEvent<HTMLDivElement>) => void;
}

const DecisionsSidebar = ({
  decisions,
  selectedDecision,
  isLoading,
  onSelectDecision,
  onScroll,
}: DecisionsSidebarProps) => {
  const t = useTranslations('legislationDecisions');

  return (
    <div
      className='w-80 border-r border-line-default bg-surface-subtle overflow-auto'
      onScroll={onScroll}
    >
      <DialogHeader className='p-4 sticky top-0 bg-surface-card border-b z-10'>
        <DialogTitle>{t('header.titleForSideBar')}</DialogTitle>
      </DialogHeader>

      <div className='divide-y'>
        {decisions.length === 0 && isLoading ? (
          <div className='flex items-center justify-center p-8'>
            <Loader2 className='w-6 h-6 text-content-muted animate-spin' />
          </div>
        ) : decisions.length > 0 ? (
          decisions.map((decision) => (
            <DecisionItem
              key={decision.identification_number}
              decision={decision}
              isSelected={
                selectedDecision?.identification_number ===
                decision.identification_number
              }
              onSelect={onSelectDecision}
            />
          ))
        ) : (
          <div className='p-6 text-center text-content-muted'>
            {t('header.noDecisionsFound')}
          </div>
        )}

        {/* Loading indicator at bottom when loading more */}
        {isLoading && decisions.length > 0 && (
          <div className='py-4 flex justify-center'>
            <Loader2 className='w-5 h-5 text-content-muted animate-spin' />
          </div>
        )}
      </div>
    </div>
  );
};

export default DecisionsSidebar;
